import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";

import { useStyles } from "../../../../../Components/CSS/TableStyle.css";
import AdminHeader from "../../../../../Components/NavBar/Admin/AdminHeader/AdminHeader";
import PageTitle from "../../../../../Components/PageTitle/PageTitle";
import AddFeeType from "../AddFeeType/AddFeeType";
import CustomEmptyMessage from "../../../../../Components/CustomEmptyMessage/CustomEmptyMessage";
import CustomSiteLoader from "../../../../../Components/CustomSiteLoader/CustomSiteLoader";
import Axios from "axios";
import { url } from "../../../../../Config/Config";
import { connect } from "react-redux";
import CustomTableHead from "../../../../../Components/Table/CustomTableHeader/CustomTableHeader";
import FeeTypeBody from "../FeeTypeBody/FeeTypeBody";
import CustomTableFooter from "../../../../../Components/Table/CutomTableFooter/CustomTableFooter";
import FeeTypeFilter from "../FeeTypeFilter/FeeTypeFilter";
import { getAdminRefreshToken } from "../../../../../Redux/Actions/actions";
import CustomBreadCrumbs from "../../../../../Components/CustomBreadCrumbs/CustomBreadCrumbs";

class ViewFeeType extends Component {
  constructor(props) {
    super(props);
    this.state = {
      column: [
        { name: "S.N." },
        { name: "Fee Type" },
        { name: "Fee Code" },
        { name: "Description" },
        { name: "Actions" },
      ],
      feeTypes: [],
      isEmpty: false,
      rowsPerPage: 10,
      page: 0,
      search: {
        name: "",
      },
    };
  }

  componentDidMount() {
    this.getFeeTypes();
  }

  getFeeTypes = async () => {
    try {
      const response = await Axios.get(`${url}/api/fee-types`, {
        headers: {
          Authorization: `Bearer ${this.props.adminToken}`,
        },
      });
      if (response.data.feesType.length !== 0) {
        this.setState({
          feeTypes: response.data.feesType,
          isEmpty: false,
        });
      } else {
        this.setState({
          feeTypes: [],
          isEmpty: true,
        });
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.getFeeTypes();
      }
    }
  };

  handleSearch = (e) => {
    this.setState({
      search: { ...this.state.search, [e.target.name]: e.target.value },
    });
  };

  handlePage = (e, newPage) => {
    this.setState({
      page: newPage,
    });
  };

  handleRowsPerPage = (e) => {
    this.setState({
      rowsPerPage: +e.target.value,
      page: 0,
    });
  };

  render() {
    const { classes } = this.props;
    const { rowsPerPage, page } = this.state;
    const filtered = this.state.feeTypes.filter((feeType) => {
      return (
        feeType.name
          .toLowerCase()
          .indexOf(this.state.search.name.toLowerCase()) !== -1
      );
    });
    return (
      <div className={classes.root}>
        <AdminHeader />
        <div className={classes.content}>
          <div className={classes.toolbar} />

          <CustomBreadCrumbs url={this.props.match.url} />
          <PageTitle title="Fee Type List" refreshUrl={this.props.match.url} />
          {this.state.feeTypes.length !== 0 && (
            <FeeTypeFilter
              data={this.state.search}
              handleSearch={this.handleSearch}
            />
          )}
          {this.state.feeTypes.length !== 0 ? (
            <Paper>
              <TableContainer>
                <Table>
                  <CustomTableHead column={this.state.column} />
                  <TableBody>
                    <AddFeeType getFeeTypes={this.getFeeTypes} />
                  </TableBody>

                  <TableBody>
                    {(rowsPerPage > 0
                      ? filtered.slice(
                          rowsPerPage * page,
                          rowsPerPage * page + rowsPerPage
                        )
                      : filtered
                    ).map((feeType, index) => (
                      <FeeTypeBody
                        key={index}
                        index={index}
                        data={feeType}
                        getFeeTypes={this.getFeeTypes}
                      />
                    ))}
                  </TableBody>

                  <CustomTableFooter
                    count={filtered.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onChangePage={this.handlePage}
                    onChangeRowsPerPage={this.handleRowsPerPage}
                  />
                </Table>
              </TableContainer>
            </Paper>
          ) : this.state.isEmpty ? (
            <CustomEmptyMessage />
          ) : (
            <CustomSiteLoader />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(ViewFeeType));
